export const menuItemsSelector = state => state?.menuItems?.get('results').toJS()
